
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import { handleError } from "../../../../common/src/utility/errorUtils";
import LoadingOverlay from "../../../../common/src/components/LoadingOverlay.vue";
import { ProductTypeStore } from "../../../../common/src/stores/ProductTypeStore";
import { ServiceTypeStore } from "../../../../common/src/stores/ServiceTypeStore";
import { OperatingRegimeTypeStore } from "../../../../common/src/stores/OperatingRegimeTypeStore";
import { ApplicationTypeStore } from "../../../../common/src/stores/ApplicationTypeStore";
import { QuiltyResourceListItem } from "@gsx/common/src/types/http/dashboard/quiltyResource";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { hasQuiltyEnterpriseSubscription } from "@gsx/common";
import { SubscriptionQuoteModalStore } from "../../../../common/src/subscription-quote/SubscriptionQuoteModalStore";

@Component({
    components: {
        LoadingOverlay,
    },
})
export default class QuiltyResourcesListItem extends Vue {
    @Inject("container") readonly container!: Container;
    readonly productTypeStore: ProductTypeStore = this.container.get(ProductTypeStore);
    readonly serviceTypeStore: ServiceTypeStore = this.container.get(ServiceTypeStore);
    readonly operatingRegimeTypeStore: OperatingRegimeTypeStore =
        this.container.get(OperatingRegimeTypeStore);
    readonly applicationTypeStore: ApplicationTypeStore = this.container.get(ApplicationTypeStore);
    readonly authStore: AuthStore = this.container.get(AuthStore);
    readonly modalStore: SubscriptionQuoteModalStore = this.container.get(
        SubscriptionQuoteModalStore,
    );

    @Prop() resource!: QuiltyResourceListItem;

    chosenPDF?: string | null = null;
    modalShowTags: boolean = false;
    tableShowTags: boolean = false;

    mounted() {
        this.productTypeStore.load().catch(handleError);
        this.serviceTypeStore.load().catch(handleError);
        this.operatingRegimeTypeStore.load().catch(handleError);
        this.applicationTypeStore.load().catch(handleError);
    }

    organizationUrl(organizationId: string) {
        return `/dashboard/organizations/${organizationId}`;
    }

    get hasQuiltyResourceAccess() {
        return hasQuiltyEnterpriseSubscription(this.authStore.user);
    }

    get sasToken() {
        return this.authStore.sasToken;
    }

    async resourceView() {
        //@ts-ignore
        $(`#resource-modal-${this.resource.quiltyResourceId}`).modal();
    }

    getProductTags(): string[] {
        return (this.resource.products || []).map(
            (tag) => this.productTypeStore.idLabelMapping.get(tag) || tag,
        );
    }

    getServiceTags(): string[] {
        return (this.resource.services || []).map(
            (tag) => this.serviceTypeStore.idLabelMapping.get(tag) || tag,
        );
    }

    getOperatingRegimeTags(): string[] {
        return (this.resource.operatingRegimeTags || []).map(
            (tag) => this.operatingRegimeTypeStore.idLabelMapping.get(tag) || tag,
        );
    }

    getApplicationTags(): string[] {
        return (this.resource.applicationTags || []).map(
            (tag) => this.applicationTypeStore.idLabelMapping.get(tag) || tag,
        );
    }

    getOrgTags(): { label: string; link?: string | undefined }[] {
        const orgTags = (this.resource.organizations || []).map((org) => ({
            label: org.organizationName,
            link: this.organizationUrl(org.organizationId),
        }));
        return [...orgTags];
    }

    getAllTags(): { label: string; link?: string | undefined }[] {
        const productTags = this.getProductTags().map((tag) => ({ label: tag }));
        const serviceTags = this.getServiceTags().map((tag) => ({ label: tag }));
        const operatingRegimeTags = this.getOperatingRegimeTags().map((tag) => ({ label: tag }));
        const applicationTags = this.getApplicationTags().map((tag) => ({ label: tag }));

        const orgTags = (this.resource.organizations || []).map((org) => ({
            label: org.organizationName,
            link: this.organizationUrl(org.organizationId),
        }));
        const customTags = (this.resource.tags || []).map((tag) => ({ label: tag }));
        return [
            ...orgTags,
            ...productTags,
            ...serviceTags,
            ...customTags,
            ...operatingRegimeTags,
            ...applicationTags,
        ];
    }

    toggleModalShowTags() {
        this.modalShowTags = !this.modalShowTags;
    }

    toggleTableShowTags() {
        this.tableShowTags = !this.tableShowTags;
    }

    openQuiltyEnterpriseModal() {
        //@ts-ignore
        $(`#resource-modal-${this.resource.quiltyResourceId}`).modal("hide");

        setTimeout(() => {
            this.modalStore.open("quilty");
        }, 300);
    }
}
